import { InformationColorSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/information-color-svg/information-color-svg.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, InformationColorSvgComponent],
  selector: 'app-information-home',
  templateUrl: './information-home.component.html',
})
export class InformationHomeComponent  {
  
}
